import * as z from 'zod'
import { DriverRegistrationRequest, ThumbType } from '~/shared/api'

export const formSchema = DriverRegistrationRequest.schema.pick({
  citizenship: true,
  passportPhotos: true,
})

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = Omit<SchemaType, 'passportPhotos'> & {
  passportPhotos: ThumbType[] | UniqueId[]
}
